import { BehaviorSubject, Observable } from 'rxjs';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { ProtocolQ, ProtocolQFilter } from './protocol';
import { catchError, finalize } from 'rxjs/operators';

import { of } from 'rxjs';
import { ProtocolQService } from '../services/protocolQ.service';
import { SignatureBox, SignatureBoxFilter } from './signatureDocumentUsers';
import { SignatureDocumentsService } from '../services/signatureDocuments.service';

export class SignatureBoxDataSource implements DataSource<SignatureBox> {

    private signatureSubject = new BehaviorSubject<SignatureBox[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private totalSubject = new BehaviorSubject<number>(0);

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public loading$ = this.loadingSubject.asObservable();
    // eslint-disable-next-line @typescript-eslint/member-ordering
    public totalItems$ = this.totalSubject.asObservable();

    constructor(private service: SignatureDocumentsService) { }

    connect(collectionViewer: CollectionViewer): Observable<SignatureBox[]> {
        return this.signatureSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.signatureSubject.complete();
        this.loadingSubject.complete();
        this.totalSubject.complete();
    }

    loadSingatureBox(filter = new SignatureBoxFilter()): void {

        this.loadingSubject.next(true);

        this.service.findAllBox(filter).pipe(
            catchError(() => of([])),
            finalize(() => this.loadingSubject.next(false))
        ).subscribe(data => {
            if (data && data.content) {
                this.signatureSubject.next(data.content as SignatureBox[]);
                this.totalSubject.next(data.totalElements as number);
            } else if (data) {
                this.signatureSubject.next(data as SignatureBox[]);
                this.totalSubject.next(data.length as number);
            } else {
                this.signatureSubject.next([]);
                this.totalSubject.next(0);
            }
        });
    }

}
